var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_warning"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1338_688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1338_688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning",
    d: "M3.60482 20.5C2.83443 20.5 2.35338 19.6655 2.73946 18.9988L11.1393 4.49434C11.5245 3.82921 12.4848 3.82921 12.87 4.49434L21.2699 18.9988C21.656 19.6655 21.1749 20.5 20.4045 20.5H3.60482ZM4.45467 19H19.5547L12.0047 6L4.45467 19ZM12.0047 17.8077C12.2335 17.8077 12.4253 17.7303 12.5801 17.5755C12.7349 17.4207 12.8123 17.2289 12.8123 17C12.8123 16.7712 12.7349 16.5793 12.5801 16.4245C12.4253 16.2697 12.2335 16.1923 12.0047 16.1923C11.7758 16.1923 11.584 16.2697 11.4292 16.4245C11.2744 16.5793 11.197 16.7712 11.197 17C11.197 17.2289 11.2744 17.4207 11.4292 17.5755C11.584 17.7303 11.7758 17.8077 12.0047 17.8077ZM11.2547 15.1923H12.7546V10.1923H11.2547V15.1923Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3af8d13531110b97e6d209a1ad598693.svg";
export { ForwardRef as ReactComponent };